(function () {
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    const section = root.matches?.('.new-in-editorial')
      ? root
      : root.querySelector?.('.new-in-editorial');

    if (!section) return;

    const items = section.querySelectorAll('[data-new-in-reveal]');

    if (REDUCED_MOTION) {
      items.forEach((item) => item.classList.add('is-in-view'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in-view');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.15 }
    );

    items.forEach((item) => observer.observe(item));
  }

  function boot() {
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
